import { render, staticRenderFns } from "./SCamera.vue?vue&type=template&id=6cd94d4e&scoped=true&"
import script from "./SCamera.vue?vue&type=script&lang=js&"
export * from "./SCamera.vue?vue&type=script&lang=js&"
import style0 from "./SCamera.vue?vue&type=style&index=0&id=6cd94d4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd94d4e",
  null
  
)

export default component.exports